import { OrderByEnum } from '@oranta-mis/sdk';
import { TranslocoHelper } from '@core/helpers/transloco.helper';
import { TableColumn, TableColumnTypeEnum } from '@oranta-mis/ui-library';

export const patientCardListColumnHeader = (i18n: TranslocoHelper): TableColumn[] => [
  { key: 'type', name: i18n.tr('type'), type: TableColumnTypeEnum.text, width: '150px' },
  { key: 'person', name: i18n.tr('doctor'), type: TableColumnTypeEnum.person, width: '250px' },
  { key: 'diagnosis', name: i18n.tr('diagnosis'), type: TableColumnTypeEnum.text },
  {
    key: 'createdAt',
    name: i18n.tr('created_at'),
    type: TableColumnTypeEnum.text,
    width: '150px',
    sort: { sortable: true, orderBy: OrderByEnum.desc },
  },
];
